import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-20 animate-fade-in-up">
      <h1 className="text-4xl font-black text-slate-900 dark:text-white mb-8 tracking-tighter">Terms of Service</h1>
      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6 text-slate-600 dark:text-slate-400">
        <p><strong>Effective Date:</strong> 12 January 2026</p>
        <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
        
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">1. Use of Website</h2>
        <p>The content on this website is for informational purposes only. You may view and share the links, but you may not claim the projects or certifications displayed as your own.</p>
        
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">2. Intellectual Property</h2>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><strong>Portfolio Content:</strong> The design, layout, branding, and biographical text contained in this website are the intellectual property of Ridwan. You may not clone, duplicate, or copy the website's design for your own use without permission.</li>
          <li><strong>Project Showcases:</strong> All project descriptions, screenshots, and case studies are my proprietary work.</li>
        </ul>

        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">3. Open Source & Licensing</h2>
        <p>Some projects displayed on this site may provide links to source code (e.g., via GitHub).</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><strong>Code Usage:</strong> Any source code made available in my public repositories is subject to the specific license attached to that repository (e.g., MIT License).</li>
          <li><strong>Distinction:</strong> The license covering the source code of a specific project does not grant you the right to use the design assets of this portfolio website.</li>
        </ul>
        
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">4. Disclaimer</h2>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><strong>"As Is" Basis:</strong> This website and its contents are provided "as is" without any warranties of any kind.</li>
          <li><strong>Demo Availability:</strong> I do not guarantee that project demos or external links will remain active or error-free indefinitely. Older projects may be taken offline for maintenance or server cost management.</li>
          <li><strong>Accuracy:</strong> Statistics shown on the Profile Dashboard (Badges, Visit Counts) are fetched from third-party sources and may experience update delays.</li>
        </ul>

        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">5. Governing Law</h2>
        <p>These Terms shall be governed and construed in accordance with the laws of Indonesia, without regard to its conflict of law provisions. Any disputes arising from the use of this website shall be resolved in the courts located in Semarang, Central Java.</p>
        
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">6. Changes to Terms</h2>
        <p>We reserve the right to modify these terms at any time without prior notice. Continued use of the site signifies your acceptance of the updated terms.</p>

        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">7. Contact Information</h2>
        <p>For any legal inquiries, please contact me at: <a href="mailto:ridwansuryantara@gmail.com" className="text-primary hover:underline">ridwansuryantara@gmail.com</a>.</p>
      </div>
    </div>
  );
};

export default TermsOfService;